/** @format */
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    OnInit,
    QueryList,
    TemplateRef,
    ViewChild,
    ViewChildren,
    ViewEncapsulation,
} from '@angular/core';
import { FudisDialogService } from '@funidata/ngx-fudis';
import { PersonDataChange, PrivatePerson } from 'common-typescript/types';
import { skip } from 'rxjs';
import { take } from 'rxjs/operators';
import {
    AppErrorHandler,
    ClassifiedVisibility,
    PersonalInfoHistoryDialogComponent,
    PrivatePersonEntityService,
    UniversityService,
} from 'sis-components';

@Component({
    selector: 'app-basic-info',
    templateUrl: './basic-info.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class BasicInfoComponent implements OnInit, AfterViewInit {
    @ViewChildren('dialogOpenTriggerButton') dialogOpenTriggerButton: QueryList<ElementRef>;
    @ViewChild('editContactDialog') editContactDialog: TemplateRef<unknown>;
    @Input() studentProfile: PrivatePerson;

    isEditEnabledByUniversity = false;
    classifiedInfoEditEnabledByUniversity = false;
    studentProfileCopy: PrivatePerson;
    history: PersonDataChange[] = null;

    classifiedVisibility: ClassifiedVisibility = {
        phoneNumberVisible: false,
        secondaryEmailVisible: false,
        primaryAddressVisible: false,
        secondaryAddressVisible: false,
        municipalityUrnVisible: false,
    };

    constructor(
        private universityService: UniversityService,
        private appErrorHandler: AppErrorHandler,
        private privatePersonEntityService: PrivatePersonEntityService,
        private dialogService: FudisDialogService,
    ) {}

    ngOnInit(): void {
        this.studentProfileCopy = { ...this.studentProfile };

        this.universityService
            .getCurrentUniversitySettings()
            .pipe(take(1), this.appErrorHandler.defaultErrorHandler())
            .subscribe(universitySettings => {
                if (universitySettings?.frontendFeatureToggles?.studentDetailsEditEnabled ?? true) {
                    this.isEditEnabledByUniversity = true;
                }
                if (universitySettings?.frontendFeatureToggles?.studentClassifiedInfoToggleable ?? true) {
                    this.classifiedInfoEditEnabledByUniversity = true;
                }
            });
    }

    ngAfterViewInit() {
        // Return focus to toggle button when cancelling cancel-operation
        this.dialogOpenTriggerButton.changes.pipe(skip(1)).subscribe(() => {
            if (this.dialogOpenTriggerButton.length > 0) {
                document.getElementById('dialogOpenTriggerButton').focus();
            }
        });
    }

    openPersonalInfoHistoryDialog(): void {
        if (!this.history) {
            this.privatePersonEntityService
                .getFullPersonDataChanges(this.studentProfileCopy.id)
                .pipe(take(1), this.appErrorHandler.defaultErrorHandler())
                .subscribe(result => {
                    this.history = result;
                    this.callPersonalInfoHistoryDialogOpener();
                });
        } else {
            this.callPersonalInfoHistoryDialogOpener();
        }
    }

    private callPersonalInfoHistoryDialogOpener() {
        this.dialogService.open(PersonalInfoHistoryDialogComponent, {
            data: {
                history: this.history,
                showCorrectedRows: false,
                studentId: this.studentProfile.id,
                arePICsIncludedInHistory: true,
            },
        });
    }
}
